export default class ProductQuery {
    constructor(
        term = null,
        tax = null,
        count = 16,
        page = 1,
        sort = null,
        filters = null,
        featured = false,
        sale = false,
        includeOldIds = null,
        excludeOldIds = null,
        includeIds = null,
        excludeIds = null,
    ) {
        let query = {
            query: {
                bool: {
                    must: [
                        {
                            match: {
                                _index: 'pelcro_products',
                            },
                        },
                        {
                            match: {
                                active: true,
                            },
                        },
                        {
                            match: {
                                hidden: false,
                            },
                        },
                        {
                            range: {
                                publishDate: { lte: 'now' },
                            },
                        },
                    ],
                    must_not: [],
                    filter: [],
                },
            },
            size: count,
            from: (page - 1) * count,
        };

        query.sort = [];

        if (featured === 'true') {
            query.sort.push({ isFeatured: 'desc' });
        }

        if (sale === 'true') {
            query.query.bool.must.push({
                match: {
                    onSale: true,
                },
            });
        }

        if (sort === 'latest' || sort === null || sort === 'latest_instock') {
            query.sort.push({ publishDate: 'desc' });
        }

        if (sort === 'latest_instock') {
            query.query.bool.must.push({
                match: {
                    inStock: true,
                },
            });
        }

        if (sort === 'price_asc') {
            query.sort.push({ price: 'asc' });
        }

        if (sort === 'price_desc') {
            query.sort.push({ price: 'desc' });
        }

        if (term !== null && term !== '') {
            query.query.bool.must.push({
                multi_match: {
                    query: term,
                    type: 'cross_fields',
                    operator: 'and',
                    fields: ['tags^5', 'name'],
                },
            });
        }

        if (tax !== '' && tax !== null) {
            query.query.bool.must.push({
                match_phrase: {
                    categories: tax,
                },
            });
        }

        if (Array.isArray(includeOldIds) && includeOldIds.length > 0) {
            query.query.bool.must.push({
                bool: {
                    minimum_should_match: 1,
                    should: includeOldIds.map(includeOldId => ({
                        match: {
                            oldId: includeOldId,
                        },
                    })),
                },
            });
        } else if (Array.isArray(includeIds) && includeIds.length > 0) {
            query.query.bool.must.push({
                bool: {
                    minimum_should_match: 1,
                    should: includeIds.map(includeId => ({
                        match: {
                            id: includeId,
                        },
                    })),
                },
            });
        }

        if (Array.isArray(excludeOldIds) && excludeOldIds.length > 0) {
            query.query.bool.must_not.push({
                bool: {
                    minimum_should_match: 1,
                    should: excludeOldIds.map(excludeOldId => ({
                        match: {
                            oldId: excludeOldId,
                        },
                    })),
                },
            });
        } else if (Array.isArray(excludeIds) && excludeIds.length > 0) {
            query.query.bool.must_not.push({
                bool: {
                    minimum_should_match: 1,
                    should: excludeIds.map(excludeId => ({
                        match: {
                            id: excludeId,
                        },
                    })),
                },
            });
        }

        if (filters !== null) {
            if (filters.status !== undefined) {
                switch (filters.status) {
                    case 'on-sale':
                        query.query.bool.must.push({
                            match: {
                                onSale: true,
                            },
                        });
                        break;
                    case 'limited-stock':
                        query.query.bool.must.push({
                            match: {
                                isLimitedStock: true,
                            },
                        });
                        break;
                }
            }

            if (filters.price !== undefined) {
                query.query.bool.must.push({
                    range: {
                        price: {
                            gte: filters.price[0],
                            lte: filters.price[1],
                        },
                    },
                });
            }

            if (filters.in_stock !== undefined || sort === 'in_stock') {
                query.query.bool.must.push({
                    match: {
                        inStock: true,
                    },
                });
            }
        }

        return query;
    }
}
